const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 1H5C2.5 1 1.5 2 1.5 4.5V7.5C1.5 10 2.5 11 5 11H8C10.5 11 11.5 10 11.5 7.5V6.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51994 1.51L4.57994 5.45C4.42994 5.6 4.27994 5.89501 4.24994 6.11001L4.03494 7.615C3.95494 8.16 4.33994 8.54001 4.88494 8.46501L6.38994 8.25001C6.59994 8.22001 6.89494 8.07001 7.04994 7.92001L10.9899 3.98C11.6699 3.3 11.9899 2.51 10.9899 1.51C9.98994 0.510004 9.19994 0.830004 8.51994 1.51Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95508 2.07501C8.29008 3.27001 9.22508 4.20501 10.4251 4.54501",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditQuestion);
export default __webpack_public_path__ + "static/media/edit-question.db5d1c4e2c0500e043a0da4eeb4133d3.svg";
export { ForwardRef as ReactComponent };